const state = {
  config: {},
  loadFile: false,
  inputs: {
    szafaPrefix: '',
    sameAkcesoria: false,
    rabatCB: false,
    rabatValue: 0
  },
  outputs: {
    szafa: {},
    podzespoly: [],
    items_przod: [],
    items_tyl: [],
    items_inne: [],
    item: {},
    cena: 0
  },
  info: {
    brak_miejsca_przod: {text: '', delay: 0, out: 'time', type: 'warning'},
    brak_miejsca_tyl: {text: '', delay: 0, out: 'time', type: 'warning'},
    mozliwa_kolizja: {text: '', delay: 0, out: 'click', type: 'danger'}
  },
  loading: false,
  refCount: 0
}

const getters = {
  loading: state => state.loading,
  info: state => state.info,
  refCount: state => state.refCount,
  loadFile: state => state.loadFile,
  config: state => state.config,
  inputs: state => state.inputs,
  outputs: state => state.outputs,
  parentUrl: state => state.parentUrl
}

const mutations = {

  SET_LOADING (state, loading) {
    if (loading) {
      state.refCount++
      state.loading = loading
    } else {
      state.refCount--
      state.loading = loading
    }
    state.loading = state.refCount !== 0
  },
  SET_INFORMATION (state, payload) {
    if (state.info[payload[0]]) {
      state.info[payload[0]].text = payload[1]
    }
    if (state.info[payload[0]] && payload[2]) {
      state.info[payload[0]].delay = payload[2]
    }
  },
  SET_LOAD_FILE (state, payload) {
    state.loadFile = payload
  },
  ADD_ITEM (state, payload) {
    state.outputs.item = payload
  },
  ADD_ITEMS (state, payload) {
    if (payload[0] === 'przod') {
      state.outputs.items_przod.push(JSON.parse(JSON.stringify(payload[1])))
      // state.outputs.items_przod.push(payload[1])
      // state.outputs.items_przod.sort()
      // state.outputs.items_przod.reverse()
      state.outputs.cena += Number(payload[1].cena)
    } else if (payload[0] === 'tyl') {
      state.outputs.items_tyl.push(payload[1])
    } else if (payload[0] === 'inne') {
      state.outputs.items_inne.push(payload[1])
    }
  },
  CHANGE_ITEMS (state, payload) {
    if (payload[0] === 'przod') {
      state.outputs.items_przod = JSON.parse(JSON.stringify(payload[1]))
    } else if (payload[0] === 'tyl') {
      state.outputs.items_tyl = JSON.parse(JSON.stringify(payload[1]))
    } else if (payload[0] === 'inne') {
      state.outputs.items_inne = JSON.parse(JSON.stringify(payload[1]))
    }
  },
  CHANGE_ITEMS_INNE (state, payload) {
    if (payload[0]) {
      const oldItem = state.outputs.items_inne.find(item => item.symbol === payload[0])
      if (oldItem) {
        oldItem.value = Number(payload[1])
      }
      // state.outputs.items_inne = state.outputs.items_inne
      state.outputs.items_inne = Object.assign([], state.outputs.items_inne)
      // state.outputs.items_inne = JSON.parse(JSON.stringify(state.outputs.items_inne))
    }
  },
  MODYFICATION_INNE (state, payload) {
    state.outputs.items_inne = JSON.parse(JSON.stringify(payload))
  },
  UPDATED_OUTPUTS (state, payload) {
    state.outputs[payload['name']] = payload['value']
  },
  UPDATED_INPUTS (state, payload) {
    state.inputs[payload['name']] = payload['value']
  },
  // UPDATED_OUTPUTS_PODZESPOLY (state, payload) {
  //   // if (state.outputs.podzespoly && state.outputs.podzespoly[payload[0]]) {
  //   state.outputs.podzespoly[payload[0]] = payload[1]
  //   state.outputs.podzespoly = JSON.parse(JSON.stringify(state.outputs.podzespoly))
  //   // }
  // },
  UPDATED_OUTPUTS_PODZESPOLY (state, payload) {
    var key = payload[1]['symbol']
    var value = payload[1]['value']

    if (state.outputs.podzespoly[payload[0]]) {
      state.outputs.podzespoly[payload[0]][key] = JSON.parse(JSON.stringify(payload[1]))
      if (value === 0 || value === '0') {
        delete state.outputs.podzespoly[payload[0]][key]
      }
    } else {
      state.outputs.podzespoly[payload[0]] = {}
      state.outputs.podzespoly[payload[0]][key] = JSON.parse(JSON.stringify(payload[1]))
    }
    state.outputs.podzespoly = JSON.parse(JSON.stringify(state.outputs.podzespoly))
  },
  LOAD_FILE (state, payload) {
    // state.inputs = Object.assign([], payload[0])
    // state.outputs = Object.assign([], payload[1])
    state.inputs = JSON.parse(JSON.stringify(payload[0]))
    state.outputs = JSON.parse(JSON.stringify(payload[1]))
  },
  REMOVE_OUTPUTS_PODZESPOLY (state, payload) {
    // console.log(payload)
    if (state.outputs.podzespoly[payload]) {
      // delete state.outputs.podzespoly[payload]
      state.outputs.podzespoly[payload] = null
    }
    state.outputs.podzespoly = JSON.parse(JSON.stringify(state.outputs.podzespoly))
  },
  REMOVE_OUTPUTS_ITEMS (state, payload) {
    if (payload[0] === 'przod') {
      delete state.outputs.items_przod[payload[1]]
    } else if (payload[0] === 'tyl') {
      delete state.outputs.items_tyl[payload[1]]
    } else if (payload[0] === 'inne') {
      delete state.outputs.items_inne[payload[1]]
    }
  },
  REMOVE_IN_OUTPUTS (state) {
    state.outputs.item = []
    state.outputs.items_przod = []
    state.outputs.items_tyl = []
    state.outputs.items_inne = []
    state.outputs.szafa = {}
    state.outputs.podzespoly = []
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js